import React from 'react';

 const Title=()=>{
     return(
         <>
         <div>
        <h1>Weather App</h1>
        <h3>Find out the weather forecast around you<br/>
             so you can prepare yourself</h3>
            
         </div>
         </>
     )

 }
 export default Title;